import React from 'react';

const LoadingScreen = () => {
  return (
    <div className="loading-screen d-flex justify-content-center align-items-center" style={{
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: '#fff',
      zIndex: 9999
    }}>
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
        <p className="mt-3">Loading Mewar University...</p>
      </div>
    </div>
  );
};

export default LoadingScreen;
